module.exports = __webpack_public_path__ + "static/kvm_13.bc1978dc.png";